import { Card, SkeletonBodyText, SkeletonDisplayText, BlockStack, Box } from '@shopify/polaris'

type Props = { lines?: number }

export function SkeletonCard({ lines = 4 }: Props) {
  return (
    <Box padding="400">
      <BlockStack gap="400">
        <Card>
          <BlockStack gap="300">
            <SkeletonDisplayText size="small" />
            <SkeletonBodyText lines={lines} />
          </BlockStack>
        </Card>
        <Card>
          <SkeletonBodyText lines={lines} />
        </Card>
      </BlockStack>
    </Box>
  )
}
